export default __webpack_public_path__ + "static/agile-kinetic-30bc4733968d4afb845eacdd7b30ba4e.png";